import { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import axios from "../lib/axios";
import {
  DEVICE_CODE_KEY,
  DEVICE_TOKEN_KEY,
  getOrCreateInstallationId,
} from "../lib/deviceIdentity";


export default function EnrollPage() {
  const [code, setCode] = useState("");
  const [label, setLabel] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  // 갤러리 전용 도메인에서 직접 /enroll 로 들어온 경우 키오스크(/)가 아닌 갤러리로 복귀
  const fromPath = useMemo(
    () => location.state?.from || (window.location.hostname.startsWith("gallery.") ? "/gallery/" : "/"),
    [location.state]
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) {
      setError("등록코드를 입력해줘.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await axios.post("/device/enroll", {
        code: trimmed,
        label: label.trim() || undefined,
        installation_id: getOrCreateInstallationId(),
      });

      localStorage.setItem(DEVICE_TOKEN_KEY, res.data.device_token);
      localStorage.setItem(DEVICE_CODE_KEY, trimmed);
      localStorage.setItem("boroo_device_enrolled_at", new Date().toISOString());

      navigate(fromPath, { replace: true });
    } catch (err) {
      const apiErr = err?.response?.data?.error;

      if (apiErr === "invalid_code") {
        setError("등록코드가 유효하지 않아. 관리자에게 확인해줘.");
      } else if (apiErr === "store_inactive") {
        setError("이 매장은 현재 비활성 상태야. 상위관리자에게 문의해줘.");
      } else {
        setError("기기 등록에 실패했어. 서버 상태나 로그를 확인해줘.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#2b2b2b] text-[#f2f2f2] p-6">
      <div className="w-full max-w-md rounded-2xl bg-[#1f1f1f] shadow-lg p-6">
        <h1 className="text-2xl font-bold mb-2">디스플레이 등록</h1>
        <p className="text-sm text-gray-300 mb-6">
          이 기기가 아직 등록되지 않았다면 관리자에게 받은 등록코드를 입력해줘.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <input
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError("");
            }}
            placeholder="등록코드 입력"
            className="w-full text-lg p-4 rounded-xl bg-[#363636] text-white outline-none"
            inputMode="text"
            autoComplete="off"
          />

          <input
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="기기 별칭(선택) 예: 강남점-iPad-01"
            className="w-full text-base p-4 rounded-xl bg-[#363636] text-white outline-none"
            autoComplete="off"
          />

          {error && <p className="text-red-300">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full p-4 rounded-xl text-lg font-semibold bg-[#8262a1] active:opacity-80 disabled:opacity-50"
          >
            {loading ? "등록 중..." : "등록하고 시작하기"}
          </button>
        </form>

        <div className="mt-6 flex items-center justify-between text-sm text-gray-300">
          <span>관리자 메뉴가 필요해?</span>
          <Link to="/admin/login" className="underline">
            관리자 로그인
          </Link>
        </div>
      </div>
    </div>
  );
}
